export default __webpack_public_path__ + "60d77e654951d912b70f8f8cd0f02d8b.png";